import React from 'react';
import { observer } from 'mobx-react-lite';

import BetSectionWrapper from '../betSectionWrapper';
import { WinPopUp } from '../../components/winPopUp';
import FooterSection from '../../components/footerSection';
import WinChanceCounter from '../../components/winChanceCounter';

const BettingPartContainer = observer(() => {
  return (
    <div className='action-panel'>
      <WinPopUp />
      <WinChanceCounter />
      <BetSectionWrapper />
      <FooterSection />
    </div>
  );
});

export default BettingPartContainer;
